import { extractMonetateData } from './server/lib/extract-monetate-data';
import { isAuthenticationEnabled } from './lib/auth/is-authentication-enabled';
import { includesBotHeader } from './lib/headers/includesBotHeader';
import { IncomingMessage } from 'http';

export const defaultFeatures = {
  features: {
    displaySEOLinks: false,
  },
};

export const getFeatures = (
  config: AppConfig,
  request: IncomingMessage
): Features => {
  // Access and decode the monetate experiences
  const monetateExperiences = extractMonetateData(request) || [];
  const authenticationEnabled = isAuthenticationEnabled(config, request);
  const displaySEOLinks =
    !!config.displaySEOLinks && includesBotHeader(request);

  return {
    authenticationEnabled,
    displaySEOLinks,
    monetateExperiences,
    peepHeader: config.peepHeader === 'true',
    mvoMode: config.MVO_MODE === 'true',
    hideAccountIcon: config.HIDE_ACCOUNT_ICON === 'true',
    hideWishListIcon: config.HIDE_WISHLIST_ICON === 'true',
    hideBasketIcon: config.HIDE_BASKET_ICON === 'true',
  };
};
